import React from 'utils/react';
import moment from 'moment-timezone';
import debug from 'utils/debug';
import Container from './Container';

const D2 = debug('c:TimeSlider:Time:index');

const TimeComponent = ({ time, isUnix }) => {
  D2.S.DEBUG('Time:', time);
  D2.S.DEBUG('isUnix:', isUnix);

  if (isUnix) {
    const formattedTime = moment(time * 1000)
      .tz(global.GEODISC_TIMEZONE)
      .format('HH:mm.ss');
    return <Container>{formattedTime}</Container>;
  }

  return <Container>{time <= 12 ? `${time} AM` : `${time - 12} PM`}</Container>;
};

export default props => (
  <React.Suspense fallback>
    <TimeComponent {...props} />
  </React.Suspense>
);
